import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading, token } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#FDFBF7' }}>
        <div className="w-10 h-10 border-4 border-[#C67A5C] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user && !token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};
